module.exports = __webpack_public_path__ + "img/heart.d64727aa.png";